// extracted by mini-css-extract-plugin
export default {"block":"Search_block__kcWzn","root":"Search_root__eiX89","CodeMirror":"Search_CodeMirror__vtYnv"};